import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'toPercentage',
    standalone: false
})
export class PorcentagePipe implements PipeTransform {
   
  /**
   * 
   * @param value valor que será evaluado para convertirlo en porcentaje
   * @returns devuelve el porcentaje en caso de ser un número, de lo contrario no sufre ningún cambio
   */
    transform(value: any) {
      const numericValue = parseFloat(value); 
        if (!isNaN(numericValue)) {
          const percentageValue = (value * 100).toFixed(2);;
          return `${percentageValue}%`;
        } else {
          return value; // Si no es un número, devolver el valor original sin cambios
        }
    }

    

}
